var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EDEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#657ABD",
    d: "M18.092 12.856c-2.147 1.11-4.388 2.27-6.119 3.169l-6.07-3.169c2.198 3.175 4.03 5.818 6.07 8.744 2.044-2.92 4.302-6.14 6.12-8.744Zm-.233-.876-5.893-3.058-5.815 3.036 5.812 3.061 5.896-3.039Zm-5.886-4.037 6.12 3.133L12 2.4l-6.096 8.695 6.07-3.152Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C68AA",
    d: "m17.859 11.98-5.893-3.058-5.815 3.036 5.812 3.061 5.896-3.039Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F48975",
    d: "m11.973 7.943 6.12 3.133L12 2.4l-6.096 8.695 6.07-3.152Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8EC66",
    d: "M11.973 7.943 12 2.4l-6.096 8.695 6.07-3.152Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50BA78",
    d: "m6.15 11.958 5.817-3.036-.004 6.098-5.812-3.062Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10AED3",
    d: "m11.973 16.025-6.069-3.169c2.198 3.175 6.07 8.744 6.07 8.744v-5.575Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeth);
export default __webpack_public_path__ + "static/media/beth.b6f1b3dd3ac2ccd0671bac8a5855f444.svg";
export { ForwardRef as ReactComponent };